const SELECTOR = 'product-card .buy-buttons-block[data-fanora-multi-variant="true"]';

function updateButtonLabel(button, label) {
  const target = button.querySelector('.add-to-cart-text__content span span')
    || button.querySelector('.add-to-cart-text__content span')
    || button.querySelector('.add-to-cart-text__content');

  if (target) {
    target.textContent = label;
  } else {
    button.textContent = label;
  }

  button.setAttribute('aria-label', label);
}

async function openQuickAdd(block, event) {
  const proxy = block.querySelector('quick-add-component.fanora-card-quick-add-proxy');
  if (!proxy) return;

  if (!customElements.get('quick-add-component')) {
    await customElements.whenDefined('quick-add-component');
  }

  if (typeof proxy.handleClick === 'function') {
    proxy.handleClick(event);
  }
}

function setupBlock(block) {
  if (!(block instanceof HTMLElement) || block.dataset.fanoraChooseOptionReady === 'true') return;

  const productCard = block.closest('product-card');
  if (!productCard) return;

  const button = block.querySelector('button[name="add"], button.add-to-cart-button');
  if (!(button instanceof HTMLButtonElement)) return;

  const label = block.dataset.fanoraChooseLabel || 'Choose option';
  updateButtonLabel(button, label);
  button.type = 'button';
  button.dataset.fanoraChooseOptionButton = 'true';
  block.dataset.fanoraChooseOptionReady = 'true';

  button.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    openQuickAdd(block, event);
  });

  button.addEventListener('mouseenter', () => {
    const proxy = block.querySelector('quick-add-component.fanora-card-quick-add-proxy');
    if (proxy && customElements.get('quick-add-component') && typeof proxy.fetchProductPage === 'function') {
      proxy.fetchProductPage(proxy.productPageUrl).catch(() => {});
    }
  }, { once: true });

  button.addEventListener('touchstart', () => {
    const proxy = block.querySelector('quick-add-component.fanora-card-quick-add-proxy');
    if (proxy && customElements.get('quick-add-component') && typeof proxy.fetchProductPage === 'function') {
      proxy.fetchProductPage(proxy.productPageUrl).catch(() => {});
    }
  }, { once: true, passive: true });
}

function init() {
  document.querySelectorAll(SELECTOR).forEach(setupBlock);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}

new MutationObserver(init).observe(document.documentElement, {
  childList: true,
  subtree: true,
});
